import { supabase } from '../../config/supabase';

export const addUserToProperty = async (userId: string, propertyId: string): Promise<void> => {
  const { error } = await supabase
    .from('users')
    .update({ property_id: propertyId })
    .eq('id', userId);

  if (error) throw error;
};

export const removeUserFromProperty = async (userId: string): Promise<void> => {
  const { error } = await supabase
    .from('users')
    .update({ property_id: null })
    .eq('id', userId);

  if (error) throw error;
};